import React from 'react';
import { ShieldCheck } from 'lucide-react';
import { Section } from './Shared';
export const Guarantee = () => <Section className="max-w-3xl" data-id="element-83" data-mp="1o2lpcw08m5y8">
    <div className="rounded-3xl bg-brand-purpleDark text-white p-8 md:p-12 text-center" data-id="element-84" data-mp="1o3doggt1mlt9">
      <ShieldCheck className="w-12 h-12 md:w-14 md:h-14 text-brand-gold mx-auto" data-id="element-85" data-mp="222wjc7wug0nm" />
      <h2 className="mt-5 text-2xl md:text-4xl font-display font-bold text-brand-goldLight leading-tight" data-id="element-86" data-mp="1x5mvgwp3rx1w">
        Tienes siete días para revisarlo
      </h2>
      <div className="mt-5 space-y-3 text-base md:text-lg text-white/85 leading-relaxed" data-id="element-87" data-mp="14fxswewqvoy6">
        <p data-id="element-88" data-mp="1j4k5w9ywg4m8">Explora los libros y conoce las herramientas por dentro.</p>
        <p data-id="element-89" data-mp="1j5vcehjqbqh1">
          Si el material no es lo que esperabas, solicita la devolución del
          100% dentro de los siete días posteriores a tu compra.
        </p>
        <p data-id="element-90" data-mp="qn7tn8s7gnj4">
          Escríbenos a{' '}
          <a href="mailto:soportelumenakasha@gmail.com" className="font-semibold text-brand-lime underline underline-offset-2" data-id="element-91" data-mp="qm6il4b6w11e">
            soportelumenakasha@gmail.com
          </a>
          .
        </p>
      </div>
    </div>
  </Section>;